import React from 'react';
import PropTypes from 'prop-types';
import IdCheckContent from './IdCheckContent';
import withIdCheck from '../withIdCheck';
import DoOnMobileButton from '../../common/DoOnMobileButton';

require('../../../lib/scanutils');

class IdCheckInPage extends React.Component {
  render = () => {
    const {
      idCheckSteps,
      activeStep: activeStepIndex,
      cameraIsOnDocType,
      scanEnded,
      embedMode
    } = this.props;
    const { onIdCheckOnMobileOpen } = this.props;

    const lastStep = activeStepIndex === idCheckSteps.length;

    return (
      <div className="document-page-container id-check">
        <div className="common-full-height-page-content">
          <div className="document-page-body">
            <IdCheckContent {...this.props} />
          </div>

          {!scanEnded && !lastStep && !cameraIsOnDocType && !embedMode && (
            <div className="document-page-footer">
              <DoOnMobileButton onClick={onIdCheckOnMobileOpen} />
            </div>
          )}
        </div>
      </div>
    );
  };
}

IdCheckInPage.propTypes = {
  onIdCheckOnMobileOpen: PropTypes.func,
  cameraIsOnDocType: PropTypes.any,
  activeStep: PropTypes.number,
  idCheckSteps: PropTypes.array,
  scanEnded: PropTypes.bool,
  embedMode: PropTypes.bool
};

export default withIdCheck(IdCheckInPage);
